/* eslint-disable max-len */
const PropTypes = require('prop-types');
const React = require('react');

/**
 * Branch renders the Branch script using the API key
 *
 * @param {Object} props component props
 * @returns {Object} React component
 */
function Branch(props) {
  const { apiKey, isActive } = props;
  if (!isActive) {
    return null;
  }

  const script = `
    (function(b,r,a,n,c,h,_,s,d,k){if(!b[n]||!b[n]._q){for(;s<_.length;)c(h,_[s++]);d=r.createElement(a);d.async=1;d.src="https://cdn.branch.io/branch-latest.min.js";k=r.getElementsByTagName(a)[0];k.parentNode.insertBefore(d,k);b[n]=h}})(window,document,"script","branch",function(b,r){b[r]=function(){b._q.push([r,arguments])}},{_q:[],_v:1},"addListener applyCode autoAppIndex banner closeBanner closeJourney creditHistory credits data deepview deepviewCta first getCode init link logout redeem referrals removeListener sendSMS setBranchViewData setIdentity track validateCode trackCommerceEvent".split(" "), 0);
    branch.init('${apiKey}');
  `;

  // eslint-disable-next-line react/no-danger
  return <script dangerouslySetInnerHTML={{ __html: script }} />;
}

Branch.propTypes = {
  /**
   * apiKey for branch integration
   */
  apiKey: PropTypes.string.isRequired,
  /**
   * flag indicating if analytics should be active
   */
  isActive: PropTypes.bool.isRequired,
};

module.exports.default = Branch;
